// Copyright 2024 Sadiant Inc. All Rights Reserved. This software is subject to a license agreement. Unauthorized or unlicensed use is prohibited.
export const environment = {
  production: true,
  configUrl: './config-release/config.release.json',
  siteUrl: 'https://www.sadianthealth.com',
  siteOgImageBase: 'https://www.sadianthealth.com/assets/og'
};
